export default function productAdditionalInformationController() {
  if (window.innerWidth < 768) {
    document.querySelectorAll('.product-additional-information__more')?.forEach(function (item) {
      item.classList.remove('open');
    });
  }
}
